export enum LockContextEnum {
    CASE_BASIC = 'CASE_BASIC',
    SUPPLIER_INVOICE = 'SUPPLIER_INVOICE'
}

export enum CaseLockOverlayAction {
    RELOAD_CASE = 'RELOAD_CASE',
    TAKE_LOCK = 'TAKE_LOCK'
}
